import { render, staticRenderFns } from "./NewUser.html?vue&type=template&id=e6a2c80a&scoped=true&"
import script from "./NewUser.ts?vue&type=script&lang=ts&"
export * from "./NewUser.ts?vue&type=script&lang=ts&"
import style0 from "./NewUser.css?vue&type=style&index=0&id=e6a2c80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a2c80a",
  null
  
)

export default component.exports